/* eslint-disable max-classes-per-file */
import {ExtendableError} from 'ts-error';
import {WndError} from 'wnd-react-utils/lib/errors';

export class MissingTokenError extends ExtendableError implements WndError {
  static code = 1000;
  code = MissingTokenError.code;
}
